import { __makeTemplateObject } from '../../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import tokens from '@lacedltd/design-tokens';
import { Item as Item$1, Trigger as Trigger2, Content as Content2 } from '../../../../../_externals/.pnpm/@radix-ui_react-accordion@1.2.0_@types_react@18.3.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@radix-ui/react-accordion/dist/index.js';
import { generatePadding, generateBorder } from '../../../../helpers/tokens.js';
import Plus from '../../../atoms/Icons/Plus/Plus.js';
import Minus from '../../../atoms/Icons/Minus/Minus.js';

var Item = styled(Item$1, {
    shouldForwardProp: function (prop) { return prop !== "darkMode"; },
})({
    overflow: "hidden",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    borderBottom: "".concat(tokens.borderWidth.xs, " solid ").concat(tokens.color.superstar[600]),
    padding: generatePadding("spacing.5", "spacing.4"),
    "&:focus-within:has(:focus-visible)": {
        outline: generateBorder("s", "solid", "airJordan.p"),
    },
}, function (_a) {
    var darkMode = _a.darkMode;
    return darkMode && {
        borderColor: tokens.color.airJordan[800],
        "&:focus-within:has(:focus-visible)": {
            borderColor: tokens.color.airJordan[800],
        },
    };
});
var Trigger = styled(Trigger2, {
    shouldForwardProp: function (prop) { return prop !== "darkMode"; },
})({
    all: "unset",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
}, function (_a) {
    var darkMode = _a.darkMode;
    return darkMode && {
        color: tokens.color.yeezy.p,
        borderColor: tokens.color.airJordan[800],
        "& > *": {
            color: tokens.color.yeezy.p,
        },
    };
});
var IconContainer = styled.div({
    display: "flex",
    marginLeft: "auto",
    border: generateBorder("xs", "solid", "transparent"),
});
var slideDown = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from {\n      height: 0;\n    }\n  to {\n    height: var(--radix-accordion-content-height);\n  }\n"], ["\n  from {\n      height: 0;\n    }\n  to {\n    height: var(--radix-accordion-content-height);\n  }\n"])));
var slideUp = keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  from {\n    height: var(--radix-accordion-content-height);\n  }\n  to {\n    height: 0;\n  }\n"], ["\n  from {\n    height: var(--radix-accordion-content-height);\n  }\n  to {\n    height: 0;\n  }\n"])));
var Content = styled(Content2)({
    overflow: "hidden",
    '[data-state="open"] &': {
        animation: "".concat(slideDown, " 200ms cubic-bezier(0.87, 0, 0.13, 1)"),
    },
    '[data-state="closed"] &': {
        animation: "".concat(slideUp, " 200ms cubic-bezier(0.87, 0, 0.13, 1)"),
    },
});
var PlusIcon = styled(Plus)({
    "[data-state=closed] &": {
        display: "inline-block",
    },
    "[data-state=open] &": {
        display: "none",
    },
});
var MinusIcon = styled(Minus)({
    "[data-state=open] &": {
        display: "inline-block",
    },
    "[data-state=closed] &": {
        display: "none",
    },
});
var templateObject_1, templateObject_2;

export { Content, IconContainer, Item, MinusIcon, PlusIcon, Trigger };
//# sourceMappingURL=Item.styles.js.map
